/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Group_Closed_CaptioningInputs */

const en_shortcut_keys_group_closed_captioning = /** @type {(inputs: Shortcut_Keys_Group_Closed_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed Captioning`)
};

const fr_shortcut_keys_group_closed_captioning = /** @type {(inputs: Shortcut_Keys_Group_Closed_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titrage`)
};

const de_shortcut_keys_group_closed_captioning = /** @type {(inputs: Shortcut_Keys_Group_Closed_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelung`)
};

const it_shortcut_keys_group_closed_captioning = /** @type {(inputs: Shortcut_Keys_Group_Closed_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli`)
};

const ru_shortcut_keys_group_closed_captioning = /** @type {(inputs: Shortcut_Keys_Group_Closed_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры`)
};

const es_shortcut_keys_group_closed_captioning = /** @type {(inputs: Shortcut_Keys_Group_Closed_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulos cerrados`)
};

const zh_cn2_shortcut_keys_group_closed_captioning = /** @type {(inputs: Shortcut_Keys_Group_Closed_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏式字幕`)
};

const ja_shortcut_keys_group_closed_captioning = /** @type {(inputs: Shortcut_Keys_Group_Closed_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クローズドキャプション`)
};

const hi_shortcut_keys_group_closed_captioning = /** @type {(inputs: Shortcut_Keys_Group_Closed_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद अनुशीर्षक`)
};

const pt_pt2_shortcut_keys_group_closed_captioning = /** @type {(inputs: Shortcut_Keys_Group_Closed_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas ocultas`)
};

/**
* | output |
* | --- |
* | "Closed Captioning" |
*
* @param {Shortcut_Keys_Group_Closed_CaptioningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_group_closed_captioning = /** @type {((inputs?: Shortcut_Keys_Group_Closed_CaptioningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Group_Closed_CaptioningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_group_closed_captioning(inputs)
	if (locale === "de") return de_shortcut_keys_group_closed_captioning(inputs)
	if (locale === "it") return it_shortcut_keys_group_closed_captioning(inputs)
	if (locale === "ru") return ru_shortcut_keys_group_closed_captioning(inputs)
	if (locale === "es") return es_shortcut_keys_group_closed_captioning(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_group_closed_captioning(inputs)
	if (locale === "ja") return ja_shortcut_keys_group_closed_captioning(inputs)
	if (locale === "hi") return hi_shortcut_keys_group_closed_captioning(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_group_closed_captioning(inputs)
	return en_shortcut_keys_group_closed_captioning(inputs)
});